import Vue from 'vue';
import Component from 'vue-class-component';
import { AuthorisationManager, Identity, Icon } from 'wc-lib';
import { Prop } from 'vue-property-decorator';
import { Service } from '../service';
import { Favourite } from '../model/favourite';
import { Links } from './links';
import { EditFavouriteItem } from './edit-favourite-item';
import Draggable from 'vuedraggable';

@Component({
  template: require('./mobile-favourite-menu.html'),
  components: {
    'wc-icon': Icon,
    'edit-favourite-item': EditFavouriteItem,
    'draggable': Draggable
  }
})
export class MobileFavouriteMenu extends Vue {
  @Prop()
  backHandler: Function;

  @Prop()
  closeMenu: Function;

  editing: boolean = false;


  get favourites() {
    return this.$store.getters['app/favourites'];
  }

  dragEnd(event) {
    let favouriteItem = this.favourites[event.newIndex];
    Service.editFavouriteOrder(favouriteItem.menuItemId, event.newIndex);
  }

  set favourites(value) {
    this.$store.commit('app/setFavourites', value);
  }

  toggleEdit() {
    this.editing = !this.editing;
  }

  callBackHandler() {
    this.backHandler();
  }

  setMenuItem(item: Favourite) {
    this.closeMenu();
    this.$store.commit('app/setCurrentMenuItem', { menuItemId: item.menuItemId , menuItemText: item.menuItemText, helpUrl: item.helpLink });
  }
}



// WEBPACK FOOTER //
// src/components/mobile-favourite-menu.ts